import React, { useContext, useEffect } from 'react'
import Checker from '../cmp/Checker.js'
import Filter from '../cmp/Filter.js'
//import RangeForm from '../cmp/RangeForm' 
import icon from '../icons.svg'

import { dataContext, localestr, toText, load, isValidDate, exportToExcel } from '../utils.js'

function RepSales({ data = undefined, actions }) {
  let wndData = ''
  let content = ''
  if (data) wndData = data.wndData
  else wndData = actions.getWndData()
  const setWndData = actions.setWndData
  const context = useContext(dataContext)
  const getSettings = context.getSettings
  const setSettings = context.setSettings
  const usersettings = getSettings()
  const msg = context.msg
  const inputRange = context.inputRange
  const OpenTabObject = context.OpenTabObject
  const setPosition = context.setPosition
  const position = context.getPosition('RepSales')
  const selData = { selPayTypes: context.data['selPayTypes'], selExcise: context.data['selExcise'], selOrderTypes: context.data['selOrderTypes'] }

  let from = new Date()
  from.setHours(0, 0, 0, 0)
  let to = new Date()
  to.setHours(23, 59, 59, 999)

  let grouping = [{ name: localestr('Автор'), value: 'author_id', checked: true, type: 'catUsers' },
  { name: localestr('Меню'), value: 'menu_id', checked: true, type: 'catGoods' },
  { name: localestr('Група'), value: 'folder_id', checked: false, type: 'fldGoods' },
  { name: localestr('Зал'), value: 'hall_id', checked: false, type: 'catHalls' },
  { name: localestr('Стіл'), value: 'table_id', checked: false, type: 'catTables' },
  { name: localestr('Підрозділ'), value: 'department_id', checked: false, type: 'catDepartments' },
  { name: localestr('Знижка'), value: 'discount_id', checked: false, type: 'catDiscounts' },
  { name: localestr('Тип оплати'), value: 'payType', checked: false, type: 'selPayTypes' },
  { name: localestr('Тип акцизу'), value: 'excise', checked: false, type: 'selExcise' },
  { name: localestr('РРО'), value: 'fiscal_id', checked: false, type: 'catDevices' },
  { name: localestr('Дата'), value: 'date_doc', checked: false, type: 'date' },
  { name: localestr('Документ'), value: 'doc_id', checked: false, type: 'docOrder' }]


  const filterData = [
    { caption: localestr('Меню'), dataId: 'menu_id', typeVal: 'catGoods' },
    { caption: localestr('Зал'), dataId: 'hall_id', typeVal: 'catHalls' },
    //{caption:localestr('Стіл'),dataId:'table_id',typeVal:'catTables'},
    { caption: localestr('Знижка'), dataId: 'discount_id', typeVal: 'catDiscounts' },
    { caption: localestr('Підрозділ'), dataId: 'department_id', typeVal: 'catDepartments' },
    { caption: localestr('Тип оплати'), dataId: 'payType', typeVal: 'selPayTypes' },
    { caption: localestr('Тип замовлення'), dataId: 'orderType', typeVal: 'selOrderTypes' },
    { caption: localestr('Автор'), dataId: 'author_id', typeVal: 'catUsers' },
    { caption: localestr('РРО'), dataId: 'fiscal_id', typeVal: 'catDevices' },
  ]


  if (usersettings) {
    if (usersettings.repSales) {
      if (usersettings.repSales.from) from = new Date(usersettings.repSales.from)
      if (usersettings.repSales.to) to = new Date(usersettings.repSales.to)
      if (usersettings.repSales.grouping) grouping = usersettings.repSales.grouping
    }
  }
  if (wndData.grouping) grouping = wndData.grouping
  if (wndData.from) from = wndData.from
  if (wndData.to) to = wndData.to

  function groupingHandler(d) {
    setWndData({ ...wndData, grouping: d })
    setSettings({ repSales: { from, to, grouping: d } })
  }

  function filterHandler(d) {
    setWndData({ ...wndData, filter: d })
    //setSettings({repSales:{from,to,grouping:d}})
  }

  function range(frm, to_) {
    //let showRange=!wndData.showRange
    let froml = from
    let tol = to
    if (isValidDate(frm)) froml = frm
    if (isValidDate(to_)) tol = to_
    if (froml > tol) {
      msg(localestr('Не правильний діапазон дат'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }])
      return
    }
    /*let Datal=table
    if (froml!==from || tol!==to) {
        Datal=undefined
    }*/
    /*setWndData({...wndData,showRange,from:froml,to:tol})
    if (!showRange) setSettings({repSales:{from:froml,to:tol,grouping}})*/
    setWndData({ ...wndData, from: froml, to: tol })
    setSettings({ repSales: { from: froml, to: tol, grouping } })
  }

  function getFolders(d) {
    let ret = ''
    if (!d) return ret
    ret = ",'" + d.id + "'"
    if (d.data) d.data.forEach(el => ret += getFolders(el))
    return ret
  }

  function getList(d) {
    let ret = ''
    if (!d) return ret
    if (Array.isArray(d)) d.forEach(el => ret += ",'" + el.id + "'")
    else ret = ",'" + (d.id || '0') + "'"
    return ret
  }

  function loadData(d) {
    setPosition('RepSales', 0)
    if (d) {
      const status = d.status
      if (status === 'OffLine') { msg(localestr('Помилка з\'єднання'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      if (status === 'error') { msg(d.msg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      let cols = d.groups.map(el => grouping.find(e => e.value === el))
      cols = cols.filter(el => el !== undefined)
      const filters = d.filters.map(el => el.caption)
      //console.log(cols)

      let ttl_qtt = 0
      let ttl_am = 0
      let ttl_dsc = 0
      let ttl_cst = 0
      let data = []
      let idx = new Array(cols.length > 1 ? cols.length - 2 : 1)
      let keys = new Array(cols.length > 1 ? cols.length - 2 : 1)
      for (let i = 0; i < d.data.length; i++) {
        const val = d.data[i]
        let prev = false
        for (let k = 0; k < cols.length - 1; k++) {
          if (keys[k] !== val[cols[k].value] || prev) {
            prev = true
            keys[k] = val[cols[k].value]
            const key = cols[k]
            let obj = null
            const item = { id: val[key.value], type: key.type, name: val[key.value], level: k, keys: keys.filter((e, id) => id < k), qtt: 0, am: 0, dsc: 0, cst: 0 }
            if (key.type.substring(0, 3) === 'cat' || key.type.substring(0, 3) === 'fld') item.name = val[key.value.substring(0, key.value.length - 2) + 'n'] || localestr('(пусто)')
            if (key.type.substring(0, 3) === 'doc') item.name = localestr('Замовлення') + ' №' + val[key.value] + ' (' + new Date(val[key.value.substring(0, key.value.length - 2) + 'd']).toLocaleString() + ')'
            if (key.type.substring(0, 3) === 'sel') item.name = context.data[key.type].find(e => e.value === val[key.value]).name
            if ((key.type.substring(0, 3) === 'cat' || key.type.substring(0, 3) === 'doc') && item.id) obj = { type: key.type, id: item.id }
            item.obj = obj
            idx[k] = data.length
            data.push(item)
          }

        }
        const key = cols[cols.length - 1]
        let obj = null
        const item = { id: val[key.value], type: key.type, name: val[key.value], level: cols.length - 1, keys: [...keys], qtt: parseFloat(val.qtt || 0), am: parseFloat(val.am || 0), dsc: parseFloat(val.dsc || 0), cst: parseFloat(val.cst || 0) }
        if (key.type.substring(0, 3) === 'cat' || key.type.substring(0, 3) === 'fld') item.name = val[key.value.substring(0, key.value.length - 2) + 'n'] || localestr('(пусто)')
        if (key.type.substring(0, 3) === 'doc') item.name = localestr('Замовлення') + ' №' + val[key.value] + ' (' + new Date(val[key.value.substring(0, key.value.length - 2) + 'd']).toLocaleString() + ')'
        if (key.type.substring(0, 3) === 'sel') item.name = context.data[key.type].find(e => e.value === val[key.value]).name
        if ((key.type.substring(0, 3) === 'cat' || key.type.substring(0, 3) === 'doc') && item.id) obj = { type: key.type, id: item.id }
        item.obj = obj
        data.push(item)
        for (let k = 0; k < cols.length - 1; k++) {
          data[idx[k]].qtt += item.qtt
          data[idx[k]].am += item.am
          data[idx[k]].dsc += item.dsc
          data[idx[k]].cst += item.cst
        }
        ttl_qtt += item.qtt
        ttl_am += item.am
        ttl_dsc += item.dsc
        ttl_cst += item.cst
      }
      const item = { id: 'totals', type: 'totals', name: localestr('Разом'), level: -1, keys: [], qtt: ttl_qtt, am: ttl_am, dsc: ttl_dsc, cst: ttl_cst }
      data.push(item)
      const caption = localestr('Звіт по продажах за період ') + new Date(d.from).toLocaleDateString() + ' - ' + new Date(d.to).toLocaleDateString() + ''
      let headcol = ''
      cols.forEach(el => headcol += '/' + el.name)
      headcol = headcol.substring(1)
      //console.log(data)
      setWndData({ ...wndData, content: { caption, headcol, filters, data } })

    } else {
      let groups = []
      let froml = from.toISOString().substring(0, 19) + 'Z'
      let tol = to.toISOString().substring(0, 19) + 'Z'
      let tz = to.getTimezoneOffset()
      if (tz < 0) tz = '%2B0' + (tz / -60) + ':00'
      else tz = '-0' + (tz / 60) + ':00'
      for (let i = 0; i < grouping.length; i++) if (grouping[i].checked) groups.push(grouping[i].value)
      if (groups.length === 0) {
        msg(localestr('Треба вибрати хоча б одне групування'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }])
        return
      }
      let filters = []
      if (wndData.filter) {
        filters = wndData.filter.filter(el => el.compare)
        for (let i = 0; i < filters.length; i++) {
          let new_el = { value: filters[i].dataId }
          if (filters[i].compare === '=' || filters[i].compare === '>' || filters[i].compare === '<') {
            if (!filters[i].value) new_el.compare = ' IS NULL'
            else if (filters[i].value.id) new_el.compare = '' + filters[i].compare + "'" + filters[i].value.id + "'"
            else new_el.compare = '' + filters[i].compare + "'" + filters[i].value + "'"
            if (filters[i].typeVal.substring(0, 3) === 'sel') new_el.caption = filters[i].caption + ' ' + filters[i].compare + ' ' + (selData[filters[i].typeVal] || []).find(x => x.value === filters[i].value).name
            else new_el.caption = filters[i].caption + ' ' + filters[i].compare + ' ' + toText(filters[i].value)
          } if (filters[i].compare === '<>') {
            if (!filters[i].value) new_el.compare = ' IS NOT NULL'
            else if (filters[i].value.id) new_el.compare = "!='" + filters[i].value.id + "'"
            else new_el.compare = '' + filters[i].compare + "'" + filters[i].value + "'"
            if (filters[i].typeVal.substring(0, 3) === 'sel') new_el.caption = filters[i].caption + ' ' + filters[i].compare + ' ' + (selData[filters[i].typeVal] || []).find(x => x.value === filters[i].value).name
            else new_el.caption = filters[i].caption + ' ' + filters[i].compare + ' ' + toText(filters[i].value)
          } else if (filters[i].compare === 'lk') {
            new_el.compare = "LIKE('%" + filters[i].value + "%')"
            if (filters[i].typeVal.substring(0, 3) === 'sel') new_el.caption = filters[i].caption + ' ' + localestr('містить') + ' ' + (selData[filters[i].typeVal] || []).find(x => x.value === filters[i].value).name
            else new_el.caption = filters[i].caption + ' ' + localestr('містить') + ' ' + toText(filters[i].value)
          }
          else if (filters[i].compare === 'nlk') {
            new_el.compare = "NOT LIKE('%" + filters[i].value + "%')"
            if (filters[i].typeVal.substring(0, 3) === 'sel') new_el.caption = filters[i].caption + ' ' + localestr('в папці') + ' ' + (selData[filters[i].typeVal] || []).find(x => x.value === filters[i].value).name
            else new_el.caption = filters[i].caption + ' ' + localestr('не містить') + ' ' + toText(filters[i].value)
          }
          else if (filters[i].compare === 'in_f') {
            new_el.value = filters[i].dataId + 'p'
            new_el.compare = 'IN(' + getFolders(filters[i].value).substring(1) + ')'
            if (filters[i].typeVal.substring(0, 3) === 'sel') new_el.caption = filters[i].caption + ' ' + filters[i].compare + ' ' + (selData[filters[i].typeVal] || []).find(x => x.value === filters[i].value).name
            else new_el.caption = filters[i].caption + ' ' + localestr('в папці') + ' ' + toText(filters[i].value)
          } else if (filters[i].compare === 'nin_f') {
            new_el.value = filters[i].dataId + 'p'
            new_el.compare = 'NOT IN(' + getFolders(filters[i].value).substring(1) + ')'
            if (filters[i].typeVal.substring(0, 3) === 'sel') new_el.caption = filters[i].caption + ' ' + localestr('не в папці') + ' ' + (selData[filters[i].typeVal] || []).find(x => x.value === filters[i].value).name
            else new_el.caption = filters[i].caption + ' ' + localestr('не в папці') + ' ' + toText(filters[i].value)
          } else if (filters[i].compare === 'in_l') {
            new_el.value = filters[i].dataId
            new_el.compare = 'IN(' + getList(filters[i].value).substring(1) + ')'
            if (filters[i].typeVal.substring(0, 3) === 'sel') new_el.caption = filters[i].caption + ' ' + localestr('в списку') + ' ' + (selData[filters[i].typeVal] || []).find(x => x.value === filters[i].value).name
            else new_el.caption = filters[i].caption + ' ' + localestr('в списку') + ' ' + toText(filters[i].value)
          } else if (filters[i].compare === 'nin_l') {
            new_el.value = filters[i].dataId
            new_el.compare = 'NOT IN(' + getList(filters[i].value).substring(1) + ')'
            if (filters[i].typeVal.substring(0, 3) === 'sel') new_el.caption = filters[i].caption + ' ' + localestr('не в списку') + ' ' + (selData[filters[i].typeVal] || []).find(x => x.value === filters[i].value).name
            else new_el.caption = filters[i].caption + ' ' + localestr('не в списку') + ' ' + toText(filters[i].value)
          }
          filters[i] = new_el
        }
      }
      load('action=repSales&data=' + encodeURIComponent(JSON.stringify({ from: froml, to: tol, tz, groups, filters })), (dt) => { loadData(dt) })
    }
  }

  function specification(obj) {
    if (!obj) return
    //console.log(obj)
    OpenTabObject(obj.type, obj.id)
  }

  if (wndData.content) {
    let filters = null
    if (wndData.content.filters.length) {
      filters = wndData.content.filters.map((el, idx) => {
        return <p key={idx}>{el}</p>
      })
      filters = <div className='rep_filters'>{filters}</div>
    }
    const items = wndData.content.data.map((el, idx) => {
      if (el.obj) return <tr tabIndex='0' key={idx}><td style={{ cursor: 'pointer' }} className={'rep_grp' + el.level} onDoubleClick={() => specification(el.obj)}>{el.name}</td><td className={'rep_grp' + el.level + ' rep_number'}>{el.qtt.toFixed(3)}</td><td className={'rep_grp' + el.level + ' rep_number'}>{el.am.toFixed(2)}</td><td className={'rep_grp' + el.level + ' rep_number'}>{el.dsc.toFixed(2)}</td><td className={'rep_grp' + el.level + ' rep_number'}>{el.cst.toFixed(2)}</td><td className={'rep_grp' + el.level + ' rep_number' + (el.am - el.cst < 0 ? ' red' : '')}>{(el.am - el.cst).toFixed(2)}</td></tr>
      else return <tr tabIndex='0' key={idx}><td className={'rep_grp' + el.level}>{el.name}</td><td className={'rep_grp' + el.level + ' rep_number'}>{el.qtt.toFixed(3)}</td><td className={'rep_grp' + el.level + ' rep_number'}>{el.am.toFixed(2)}</td><td className={'rep_grp' + el.level + ' rep_number'}>{el.dsc.toFixed(2)}</td><td className={'rep_grp' + el.level + ' rep_number'}>{el.cst.toFixed(2)}</td><td className={'rep_grp' + el.level + ' rep_number' + (el.am - el.cst < 0 ? ' red' : '')}>{(el.am - el.cst).toFixed(2)}</td></tr>
    })
    content = <><h3 className='rep_caption'>{wndData.content.caption}</h3>{filters}
      <table className='rep_table'>
        <thead><tr><th>{wndData.content.headcol}</th><th>{localestr('Кількість')}</th><th>{localestr('Сума')}</th><th>{localestr('Знижка')}</th><th>{localestr('Вартість')}</th><th>{localestr('Прибуток')}</th></tr></thead>
        <tbody>{items}</tbody>
      </table>
    </>
  }

  //const showRange = wndData.showRange ? <RangeForm from={from} to={to} setRng={range}/> : ''  //+
  const setPos = target => {
    if (!target) return
    //if(!position) return
    target.scrollTop = position
  }

  let btn2 = null
  if (content) {
    btn2 = <div className='no-print' style={{ position: 'absolute', top: '5px', right: '5px', display: 'flex', gap: '5px' }}>
      <div onClick={e => window.print()} style={{ cursor: 'pointer', }}>
        <img style={{ width: '24px', height: '24px' }} src={icon + '#b503'} alt='' />
      </div>
      <div style={{ cursor: 'pointer', }} onClick={() => exportToExcel(wndData)}>
        <img style={{ width: '24px', height: '24px' }} src={icon + '#xlsx'} alt='' />
      </div>
    </div>
  }

  useEffect(() => {
    if (wndData && wndData.run) setTimeout(loadData, 200)
    // eslint-disable-next-line 
  }, [])

  return (
    <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'row' }}>
      <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
        <div className='toolBar no-print'>
          <div tabIndex='0' onClick={() => { loadData() }} onKeyUp={(e) => { if (e.key === 'Enter') loadData() }}
            style={{ alignSelf: 'center', lineHeight: '30px', height: '30px', width: '95px', padding: '0px 2px 0 6px', color: '#FFF', userSelect: 'none', cursor: 'pointer', background: 'url(' + icon + '#btn95v) no-repeat', backgroundSize: '102px 30px' }}>
            <img style={{ width: '12px', height: '24px', padding: '2px', verticalAlign: 'middle' }} src={icon + '#run'} alt={localestr('Вивести')} />&nbsp;
            {localestr('Вивести')}
          </div>
          <div tabIndex='0' onClick={() => { inputRange(from, to, range) }} onKeyUp={(e) => { if (e.key === 'Enter') range() }}
            style={{ alignSelf: 'center', lineHeight: '30px', height: '30px', width: '192px', padding: '0px 2px 0 6px', userSelect: 'none', cursor: 'pointer', color: '#FFF', background: 'url(' + icon + '#btn185v) no-repeat', backgroundSize: '192px 30px' }}>
            {toText(from)}-{toText(to)}
            <img style={{ width: '24px', height: '24px', verticalAlign: 'middle' }} src={icon + '#cal_w'} alt={localestr('Інтервал дат')} />
          </div>
          <div style={{ flexGrow: '10' }}></div>
        </div>
        <div className='reportContent' style={{ position: 'relative' }} ref={el => { setPos(el) }} onScroll={e => setPosition('RepSales', e.target.scrollTop)}>{content}{btn2}</div>
      </div>
      <div className='reportTuns no-print'>
        <Checker caption={localestr('Групування')} data={grouping} setData={groupingHandler} />
        <Filter filterData={filterData} filter={wndData.filter} setFilter={filterHandler} />
      </div>
      {/*showRange*/}
    </div>
  )

}


export default RepSales